import logo from '@/assets/images/logo/txng_logo.png'
// import logo from '@/assets/images/logo/HBT.jpg'
import LinkCusstom from '@/components/common/LinkCusstom'
import ButtonCustom from '@/components/ui/ui-react-antd/MyButton/Button'
import ROUTER from '@/routes/ROUTER'
import { MenuUnfoldOutlined } from '@ant-design/icons'
import { FloatButton, Layout } from 'antd'
import { PanelLeft } from 'lucide-react'
import type React from 'react'
import { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import BreadcrumbHome from '../BreadcrumbHome/BreadcrumbHome'
import HeaderMain from '../Header'
import MenuLeft from '../MenuLeft'
import { UserMenuStyled } from './styled'

const { Sider, Content } = Layout

interface LayoutAdminProps {
  children?: React.ReactNode
  selectedKey?: string[]
  menuAdmin?: any[]
  onClickMenu?: (menu: any) => void
}

const LayoutAdmin = ({
  children,
  selectedKey = ['/'],
  menuAdmin = [],
  onClickMenu = () => {},
}: LayoutAdminProps) => {
  const [collapsemenu, setcollapsemenu] = useState(false)
  const [hiddenMenu, setHiddenMenu] = useState(false)
  const location = useLocation()
  const navigate = useNavigate()

  const onChange = (menu: any) => {
    onClickMenu(menu)
  }

  // biome-ignore lint/correctness/useExhaustiveDependencies: Dùng location làm trigger chuyển trang
  useEffect(() => {
    const bodyAdmin = document.getElementById('body-admin-scroll')
    !!bodyAdmin && bodyAdmin.scrollTo({ top: 0, left: 0, behavior: 'smooth' })
  }, [location])

  return (
    <Layout style={{ minHeight: '100vh', background: '#f5f5f5' }}>
      {menuAdmin.length > 0 && !hiddenMenu && (
        <Sider
          trigger={null}
          collapsible
          collapsed={collapsemenu}
          width={250}
          collapsedWidth={52}
          style={{
            background: '#fff',
            position: 'sticky',
            top: 0,
            height: '100vh',
            borderRight: '1px solid #ccc',
            marginRight: '8px',
            overflow: 'hidden auto',
          }}
          className="sider-custom-scroll"
        >
          <LinkCusstom
            to={ROUTER.HOME}
            className={`d-flex pointer p-3 align-items-center`}
            style={{
              height: '60px',
              borderBottom: '1px solid #f0f0f0',
              justifyContent: 'center',
              padding: 8,
            }}
          >
            <img src={logo} width={46} height={46} alt="Logo" />
            {!collapsemenu && (
              <div
                className="d-flex justify-content-center ml-2 flex-column"
                style={{ width: '100%' }}
              >
                <div
                  className="fw-600 line-height-1"
                  style={{
                    color: 'var(--main-color)',
                    fontSize: 16,
                  }}
                >
                  TXNG
                </div>
                <div className="line-height-1" style={{ color: '#888', fontSize: 10 }}>
                  Hệ thống truy xuất nguồn gốc
                </div>
                <div className="line-height-1" style={{ color: '#888', fontSize: 10 }}>
                  tỉnh Điện Biên
                </div>
                {/* 
                <div className="fw-600 line-height-1" style={{ color: 'var(--main-color)', fontSize: 11 }}>
                  CÔNG TY CỔ PHẦN CÔNG NGHỆ HOA BAN TECH
                </div>
                */}
              </div>
            )}
          </LinkCusstom>
          <UserMenuStyled
            $themedark={false}
            $collapsemenu={collapsemenu}
            style={{
              border: 'none',
              boxShadow: 'none',
              marginLeft: 0,
              width: '100%',
            }}
          >
            <div
              className={`side-bar-wrapper d-flex justify-content-space-between flex-column`}
              style={{ height: 'calc(100vh - 60px)' }}
            >
              <MenuLeft
                onChange={onChange}
                selectedKey={selectedKey}
                menu={menuAdmin}
                collapsemenu={collapsemenu}
              />
            </div>
          </UserMenuStyled>
        </Sider>
      )}

      {!!hiddenMenu && (
        <FloatButton
          style={{ left: 20 }}
          onClick={() => setHiddenMenu(false)}
          tooltip={'Mở menu'}
          icon={<MenuUnfoldOutlined />}
        />
      )}

      <Layout
        style={{
          background: '#f5f5f5',
          padding: '8px 8px 8px 0',
          minWidth: 0,
          height: '100vh',
          overflow: 'hidden auto',
        }}
      >
        <div
          style={{
            background: '#fff',
            borderRadius: 8,
          }}
        >
          {/* Khối Header (nửa trên của thẻ trắng) */}
          <div
            style={{
              padding: '4px 12px',
              borderBottom: '1px solid #ccc',
              zIndex: 10,
              display: 'flex',
              alignItems: 'center',
            }}
          >
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                flex: '0 0 auto',
              }}
            >
              <ButtonCustom
                variant="text"
                onClick={() => setcollapsemenu(!collapsemenu)}
                style={{
                  width: 32,
                  height: 32,
                  padding: 0,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  color: '#666',
                }}
              >
                <PanelLeft size={20} />
              </ButtonCustom>
              <span
                className="pb-2"
                style={{
                  color: 'oklch(0.552 0.016 285.938)',
                  marginLeft: 16,
                  marginRight: 16,
                }}
              >
                |
              </span>
              <BreadcrumbHome className="breadcrumb-custom m-0" />
            </div>
            <div style={{ flex: '1 1 auto', minWidth: 0 }}>
              <HeaderMain />
            </div>
          </div>

          {/* Khối Content (nửa dưới của thẻ trắng) */}
          <Content
            id="body-admin-scroll"
            style={{
              boxShadow: '0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px -1px rgba(0, 0, 0, 0.1)',
            }}
          >
            {children}
          </Content>
        </div>
      </Layout>
    </Layout>
  )
}

export default LayoutAdmin
